/* ============================================================================
   assets/cutoff-engine.js
   Motore condiviso per il calcolo della spedizione prevista.

   FONTE CANONICA. Usato da:
     - sections/cut-off-team.liquid          (vetrina, come window.CutOffEngine)
     - app tag ordine, lib/motore.js         (Node, come require/import)

   La matematica è INVARIATA rispetto alla versione precedente. L'unica
   differenza è il wrapper UMD e l'esposizione di alcune funzioni che prima
   restavano interne: previsioneISO, festivita, pasqua.

   Nessuna dipendenza.
   ========================================================================== */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;      // Node / bundler
  else if (typeof define === 'function' && define.amd) define(function () { return api; });
  if (root) root.CutOffEngine = api;                                           // browser
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var DAY = 86400000;
  var TZ_DEFAULT = 'Europe/Rome';

  /* -- calendario civile: ms UTC usati come "data pura", senza fuso -- */
  function civil(y, m, d) { return Date.UTC(y, m - 1, d); }
  function shift(ms, n)   { return ms + n * DAY; }
  function weekday(ms)    { return new Date(ms).getUTCDay(); }
  function key(ms) {
    var t = new Date(ms);
    return t.getUTCFullYear() + '-' +
           String(t.getUTCMonth() + 1).padStart(2, '0') + '-' +
           String(t.getUTCDate()).padStart(2, '0');
  }

  /* -- "adesso" letto nel fuso indicato (default Europe/Rome) -- */
  var fmtCache = {};
  function partsFmt(tz) {
    if (!fmtCache[tz]) {
      fmtCache[tz] = new Intl.DateTimeFormat('en-CA', {
        timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      });
    }
    return fmtCache[tz];
  }
  function adesso(tz, at) {
    var p = {};
    partsFmt(tz || TZ_DEFAULT).formatToParts(at || new Date())
      .forEach(function (x) { p[x.type] = x.value; });
    var H = parseInt(p.hour, 10); if (H === 24) H = 0;
    return { y: +p.year, m: +p.month, d: +p.day, H: H, M: +p.minute, S: +p.second };
  }

  /* -- festività nazionali italiane -- */
  function pasqua(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100,
        d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
        h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4), k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7,
        m = Math.floor((a + 11 * h + 22 * l) / 451),
        mo = Math.floor((h + l - 7 * m + 114) / 31),
        da = ((h + l - 7 * m + 114) % 31) + 1;
    return civil(y, mo, da);
  }
  var FISSE = [[1,1],[1,6],[4,25],[5,1],[6,2],[8,15],[11,1],[12,8],[12,25],[12,26]];
  var annoCache = {};
  function festivita(y) {
    if (annoCache[y]) return annoCache[y];
    var s = {};
    FISSE.forEach(function (p) { s[key(civil(y, p[0], p[1]))] = 1; });
    s[key(shift(pasqua(y), 1))] = 1;             // Lunedì dell'Angelo
    annoCache[y] = s;
    return s;
  }
  function lavorativo(ms, extra) {
    var w = weekday(ms);
    if (w === 0 || w === 6) return false;
    var k = key(ms);
    if (extra && extra[k]) return false;
    return !festivita(new Date(ms).getUTCFullYear())[k];
  }

  /* -- previsione di spedizione --------------------------------------------
     cfg = { tz, giorni, cutoffOra: 'HH:MM', festivitaExtra: ['AAAA-MM-GG'] }
     Del cut-off si usa SOLO l'orario: il giorno è sempre quello odierno.
     Ordine entro l'orario  -> oggi vale come 1° giorno lavorativo.
     Ordine oltre l'orario  -> si parte dal primo giorno lavorativo successivo.
     (cut-off 08:00 → un ordine delle 08:00:01 conta già dal giorno dopo)
  -------------------------------------------------------------------------- */
  function previsione(cfg, at) {
    var tz = cfg.tz || TZ_DEFAULT;
    var extra = {};
    (cfg.festivitaExtra || []).forEach(function (s) { if (s) extra[s] = 1; });

    var p  = adesso(tz, at);
    var hm = String(cfg.cutoffOra || '00:00').split(':');
    var limite = (+hm[0]) * 3600 + (+hm[1]) * 60 + (+(hm[2] || 0));
    var ora    = p.H * 3600 + p.M * 60 + p.S;

    var giorno = civil(p.y, p.m, p.d);
    if (ora > limite) giorno = shift(giorno, 1);
    var guard = 0;
    while (!lavorativo(giorno, extra) && guard++ < 400) giorno = shift(giorno, 1);

    var n = 1; guard = 0;
    var totale = Math.max(1, parseInt(cfg.giorni, 10) || 1);
    while (n < totale && guard++ < 900) {
      giorno = shift(giorno, 1);
      if (lavorativo(giorno, extra)) n++;
    }
    return giorno;
  }

  /* La stessa previsione, già in AAAA-MM-GG. È la forma che serve al tag. */
  function previsioneISO(cfg, at) { return key(previsione(cfg, at)); }

  /* -- formattazione -- */
  var FMT_LUNGO = new Intl.DateTimeFormat('it-IT', {
    timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long'
  });
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

  /* -- segnaposto -----------------------------------------------------------
     L'editor rich text di Shopify salva { } come &lcub; &rcub; per proteggere
     la sintassi Liquid: vanno riconvertite prima della sostituzione.
  -------------------------------------------------------------------------- */
  function graffe(s) {
    return String(s || '')
      .replace(/&lcub;|&lbrace;|&#123;|&#x7[bB];/g, '{')
      .replace(/&rcub;|&rbrace;|&#125;|&#x7[dD];/g, '}');
  }
  function tpl(str, vars) {
    return graffe(str).replace(/\{\s*(\w+)\s*\}/g, function (m, k) {
      return vars[k] != null ? vars[k] : m;
    });
  }

  /* -- helper di fuso, condivisi con l'app ----------------------------------
     La data civile di un istante, letta nel fuso dello store. Serve ogni volta
     che da un date_time si deve ricavare un AAAA-MM-GG: tagliare i primi 10
     caratteri della stringa UTC sbaglia di un giorno per gli orari serali.
  -------------------------------------------------------------------------- */
  var fmtData = {};
  function dataLocale(at, tz) {
    tz = tz || TZ_DEFAULT;
    if (!fmtData[tz]) {
      fmtData[tz] = new Intl.DateTimeFormat('en-CA', {
        timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit'
      });
    }
    var p = {};
    fmtData[tz].formatToParts(at instanceof Date ? at : new Date(at))
      .forEach(function (x) { p[x.type] = x.value; });
    return p.year + '-' + p.month + '-' + p.day;
  }
  /* Solo l'orario HH:MM di un date_time, letto nel fuso dello store. */
  function oraLocale(at, tz) {
    var p = adesso(tz, at instanceof Date ? at : new Date(at));
    return String(p.H).padStart(2, '0') + ':' + String(p.M).padStart(2, '0');
  }

  /* -- scrittura dell'attributo carrello (solo browser) ---------------------
     Resta per compatibilità con eventuali usi nel tema. In Node non viene mai
     invocata; se lo fosse, esce senza fare nulla invece di lanciare.
  -------------------------------------------------------------------------- */
  var inFlight = false;
  function salvaSulCarrello(attrs, done) {
    if (typeof fetch !== 'function' || typeof document === 'undefined') return;
    if (inFlight) return;
    var root = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes &&
                window.Shopify.routes.root) || '/';
    inFlight = true;
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cur = cart.attributes || {};
        var cambiato = Object.keys(attrs).some(function (k) { return cur[k] !== attrs[k]; });
        if (!cambiato) { inFlight = false; if (done) done(cart, false); return null; }
        var body = new FormData();
        Object.keys(attrs).forEach(function (k) { body.append('attributes[' + k + ']', attrs[k]); });
        return fetch(root + 'cart/update.js', { method: 'POST', body: body })
          .then(function (r) { return r.json(); })
          .then(function (c) { inFlight = false; if (done) done(c, true); });
      })
      .catch(function (e) { inFlight = false; console.warn('[cutoff] carrello non aggiornato', e); });
  }

  /* -- parametri memorizzati nel browser (solo browser) -- */
  var CHIAVE = 'cutoff:parametri';
  function ricorda(cfg) {
    try {
      localStorage.setItem(CHIAVE, JSON.stringify({
        tz: cfg.tz, giorni: cfg.giorni, cutoffOra: cfg.cutoffOra,
        festivitaExtra: cfg.festivitaExtra || []
      }));
    } catch (e) { /* navigazione privata, storage pieno o Node: si prosegue */ }
  }
  function ricordato() {
    try {
      var v = JSON.parse(localStorage.getItem(CHIAVE) || 'null');
      return (v && v.giorni && v.cutoffOra) ? v : null;
    } catch (e) { return null; }
  }

  return {
    previsione: previsione,
    previsioneISO: previsioneISO,
    lavorativo: lavorativo,
    festivita: festivita,
    pasqua: pasqua,
    iso: key,
    dataLocale: dataLocale,
    oraLocale: oraLocale,
    parti: adesso,
    etichetta: function (ms) { return cap(FMT_LUNGO.format(new Date(ms))); },
    tpl: tpl,
    graffe: graffe,
    ricorda: ricorda,
    ricordato: ricordato,
    salvaSulCarrello: salvaSulCarrello
  };
});
